var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters, mapActions } from 'vuex';
import { ACCOUNT } from '@/stores/defs';
import { API_CMDS } from '@/common/messages/api.cmds';
import customerService from '@Service/customer.service';
import addressService from '@Service/address.service';
import locationsMixin from '@Mixin/locationsMixin';
import accountMixin from '@Mixin/accountMixin';
import AddressModel from '@/models/AddressModel';
import { uniqBy, merge, map } from 'lodash';
// TODO Address Vue Mixin
/*
    Address mixin
    Get/Set User Address (saves in state)
    Use cases to cover:
    An initial address is entered and stored in state to be used as a guest address.
    An initial address is not entered.
    The user signs up and the create user process adds a copy of the initial address to the user account
    The user doesn't sign up and never enters an address.
        If service type pickup is selected order is valid.
        If service type is delivery order is invalid, error is shown and user must add an address
*/
var addressMixin = {
    mixins: [locationsMixin, accountMixin],
    data: function () {
        return {
            currentAddressEntry: '',
            searchedAddress: null,
        };
    },
    computed: __assign({}, mapGetters({
        getAddresses: ACCOUNT.GET_ADDRESSES,
        getGuestAddress: ACCOUNT.GET_GUEST_ADDRESS,
        getSelectedAddressId: ACCOUNT.GET_SELECTED_ADDRESS,
    }), { getAddressForGmap: function () {
            var newAddress = this.newAddress;
            if (!newAddress) {
                return;
            }
            if (newAddress.cmd === API_CMDS.ADDRESS.ADD) {
                return 'Enter Street Address';
            }
            if (!newAddress.address) {
                return;
            }
            var streetNumber = this.getStreetNumber(newAddress);
            var streetName = this.getStreetName(newAddress);
            return streetNumber + " " + streetName;
        },
        userHasAddresses: function () {
            var userAddresses = this.getUserAddresses() || [];
            return userAddresses.length > 0;
        } }),
    methods: __assign({}, mapActions({
        addAddress: ACCOUNT.ADD_ADDRESS,
        removeAddress: ACCOUNT.DELETE_ADDRESS,
        editAddress: ACCOUNT.EDIT_ADDRESS,
        setSelectedAddressId: ACCOUNT.SET_SELECTED_ADDRESS,
    }), { getStreetNumber: function (address) {
            return address.addressComponents.streetNumber.shortName;
        },
        getStreetName: function (address) {
            return address.addressComponents.streetName.shortName;
        },
        getUserAddresses: function () {
            var addresses = this.getAddresses;
            var customer = this.customer;
            if (customer) {
                addresses = merge(addresses, customer.addresses);
                addresses = uniqBy(addresses, 'id');
            }
            addresses = map(addresses, function (address) {
                if (!(address instanceof AddressModel)) {
                    return new AddressModel(address);
                }
                return address;
            });
            return addresses;
        },
        getUserAddressCurrent: function () {
            var addresses = this.getUserAddresses();
            if (addresses.length > 0) {
                var useAddress = addresses[0];
                return {
                    latitude: useAddress.latitude,
                    longitude: useAddress.longitude
                };
            }
            return {
                latitude: 0,
                longitude: 0,
            };
        },
        setUserAddress: function (searchAddress) { },
        isGooglePlace: function (address) {
            var scope = address.scope;
            return (scope === 'GOOGLE');
        },
        _addInitialAddress: function () {
            var _this = this;
            var address = this.getGuestAddress;
            if (!address) {
                return;
            }
            this.addUserAddress(address).then(function (response) {
                var body = response.data.body;
                if (!body) {
                    var responseString = JSON.stringify(response);
                    console.error("Add user address failed: " + responseString);
                    return;
                }
                var address = body.address;
                var convertedAddress = new AddressModel(address);
                _this.addAddress(convertedAddress);
                _this.setGuestAddress(address);
            });
        },
        addUserAddress: function (address) {
            var useAddress = address;
            var isGooglePlace = this.isGooglePlace(address);
            if (isGooglePlace) {
                useAddress = addressService.extractGPLaceProps(address);
            }
            var addressModel = new AddressModel(useAddress);
            var customerId = this.userId;
            var phone = this.userPhone;
            var name = this.userName;
            var locationBase = this.location.id;
            var sendAddress = {
                address: addressModel,
                addressComponents: addressModel.addressComponents,
                b: locationBase,
                cb: customerId,
                cmd: 'add',
                id: null,
                formatted_address: addressModel.formattedAddress,
                latitude: "" + addressModel.latitude,
                longitude: "" + addressModel.longitude,
                phone: phone,
                name: name,
                aptNum: '',
                note: '',
            };
            var addAddressPromise = customerService.addDeliveryAddress(sendAddress);
            if (!addAddressPromise) {
                this.setGuestAddress(address);
                return;
            }
            return addAddressPromise;
        },
        addAddressFromField: function () {
            var el = this.$el;
            var addressField = el.querySelector('#address-field');
            this.newAddress = __assign({}, this.newAddress, { address: addressField.value });
        },
        deleteAddress: function (addressId) {
            var sendDeletion = {
                cmd: 'delete',
                cb: this.userId,
                id: addressId,
            };
            var deleteAddressPromise = customerService.deleteAddress(sendDeletion);
            if (!deleteAddressPromise) {
                console.warn('Failed to delete address');
                return;
            }
            return deleteAddressPromise;
        },
        setAddressOnChange: function (newAddress) {
            this.searchAddress = newAddress;
            var formattedAddress = newAddress.formatted_address;
            this.currentAddressEntry = formattedAddress;
        } }),
};
export default addressMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/addressMixin.ts
// module id = x4IU
// module chunks = 18